import { CourseAccordion } from '../../../components/program/CourseAccordion';
import { InformativeCourseAccordion } from '../../../components/program/InformativeCourseAccordion';
import { ModuleRow } from '../../../components/program/ModuleRow';
import { Course } from '../../../data/programs';
import { SavannaCourseLocation } from '../../../data/savannaCurriculum';

interface Props {
  /** Every Savanna-backed course in the program, in course order. */
  locations: SavannaCourseLocation[];
  /** The first course with its content. */
  course: Course | undefined;
  covered: boolean;
  onSubscribe: () => void;
}

/**
 * Program structure for someone who has not joined: a shape and a price.
 *
 * Every course is fetched eagerly on first render - product wants the full
 * paywall split visible up front rather than behind a click - but only the
 * first opens by default. Courses 2..N start closed with a "Subscribe to
 * unlock" badge and open on request, already holding their content.
 *
 * Leaves are MODULES - Savanna's blocks - with a Free / Partially Free / Paid
 * badge each and nothing below them to open. Someone deciding whether to join
 * needs the shape of the course and what a subscription adds, not a list of
 * every page in it.
 */
export const InformativeStructure = ({
  locations,
  course,
  covered,
  onSubscribe,
}: Props) => {
  return (
    <>
      {course && (
        <CourseAccordion
          course={course}
          defaultOpen
          paidUnlocked={covered}
          onSubscribe={onSubscribe}
        >
          <div className="flex flex-col divide-y divide-border-secondary">
            {course.modules.map((module, index) => (
              <ModuleRow
                key={module.id}
                index={index + 1}
                module={module}
                paidUnlocked={covered}
              />
            ))}
          </div>
        </CourseAccordion>
      )}
      {locations.slice(1).map((location, index) => (
        <InformativeCourseAccordion
          key={location.courseDefinitionId}
          location={location}
          // 1-based, and offset past the first course, which is rendered above.
          index={index + 2}
          paidUnlocked={covered}
          onSubscribe={onSubscribe}
        />
      ))}
    </>
  );
};
